/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Plh_Col_MaterialInputs */

const vi_pkl_plh_col_material = /** @type {(inputs: Pkl_Plh_Col_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư`)
};

/**

* @param {Pkl_Plh_Col_MaterialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_plh_col_material = /** @type {((inputs?: Pkl_Plh_Col_MaterialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Plh_Col_MaterialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_plh_col_material(inputs)
});